export default __webpack_public_path__ + "static/tagoloan-3d633d83e51596ae5075bdcfa90c7820.jpg";